import React, { useEffect, useState } from 'react';
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from './ui/alert-dialog';
import { useEducationAuth } from '../contexts/EducationAuthContext';
import { useLanguage } from '../contexts/LanguageContext';
import { GUEST_DATA_EVENT, adoptGuestData, dismissGuestPrompt, guestPromptDismissedFor, hasGuestStash } from '../utils/accountDataPrivacy';
import { getToken, tokenUserId } from '../utils/auth';

// Guest data on this device joins an account only after the learner explicitly confirms.
export const GuestDataPrompt = () => {
  const { isAuthenticated } = useEducationAuth();
  const { language } = useLanguage();
  const es = language === 'es';
  const [tick, setTick] = useState(0);
  useEffect(() => {
    const on = () => setTick((n) => n + 1);
    window.addEventListener(GUEST_DATA_EVENT, on);
    return () => window.removeEventListener(GUEST_DATA_EVENT, on);
  }, []);
  const uid = isAuthenticated ? tokenUserId(getToken() || '') : null;
  const open = Boolean(uid) && hasGuestStash() && !guestPromptDismissedFor(uid) && tick >= 0;
  if (!open) return null;
  const keep = () => { adoptGuestData(); dismissGuestPrompt(uid); window.location.reload(); };
  return (
    <AlertDialog open>
      <AlertDialogContent data-testid="guest-data-prompt">
        <AlertDialogHeader>
          <AlertDialogTitle>{es ? '¿Agregar los datos de invitado a su cuenta?' : 'Add guest data to your account?'}</AlertDialogTitle>
          <AlertDialogDescription>
            {es
              ? 'Este dispositivo tiene datos guardados antes de iniciar sesión (por ejemplo, diario de sueño o progreso de práctica). Solo se agregarán si usted lo confirma. Los datos que su cuenta ya tiene nunca se sobrescriben. Si elige "Ahora no", los datos de invitado permanecen en este dispositivo y vuelven a estar disponibles al cerrar sesión.'
              : 'This device has data saved before you signed in (for example a sleep journal or practice progress). It is only added if you confirm. Data your account already has is never overwritten. If you choose "Not now", the guest data stays on this device and is available again after you sign out.'}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel onClick={() => dismissGuestPrompt(uid)} data-testid="guest-data-prompt-decline">{es ? 'Ahora no' : 'Not now'}</AlertDialogCancel>
          <AlertDialogAction onClick={keep} data-testid="guest-data-prompt-accept">{es ? 'Agregar a mi cuenta' : 'Add to my account'}</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
